// extracted by mini-css-extract-plugin
module.exports =  {"label":"e3afc254ff--label--XI5A0","pros":"e3afc254ff--pros--QaXPQ","cons":"e3afc254ff--cons--I13Sb"};